/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface VideoContent {
  name?: string;
  id?: string;
}

export interface Article {
  duration?: string;
  id?: string;
  title?: string;
  type?: string;
  content?: Content[];
}

export interface Content {
  data?: object;
  type?: string;
}

export interface SearchResponseArticle {
  /** @format int32 */
  total?: number;

  /** @format int32 */
  pages?: number;
  hasMore?: boolean;
  items?: Article[];
}

export interface Category {
  name?: string;
  id?: string;
}

export interface SearchParams {
  query: string;

  /** @format int32 */
  page?: number;

  /** @format int32 */
  size?: number;
}

import { HttpClient } from "../../client";
import { RequestParams } from "../../client/types";

/**
 * @title Микросервис Помощь
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://comm-help.ndbo.dev.rshbdev.ru
 * @contact ООО РСХБ-ИНТЕХ, НДБО ЮЛ, Коммуникации <info@rshbintech.ru>
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Видео
     * @name GetAllVideo
     * @summary Получить все видео
     * @request GET:/api/help/v1/videos
     * @secure
     */
    getAllVideo: (params: RequestParams = {}) =>
      this.request<VideoContent[], void>({
        path: `/api/help/v1/videos`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Видео
     * @name GetVideoContent
     * @summary Получить видео
     * @request GET:/api/help/v1/videos/{videoId}
     * @secure
     */
    getVideoContent: (videoId: string, params: RequestParams = {}) =>
      this.request<string[], void>({
        path: `/api/help/v1/videos/${videoId}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Видео
     * @name GetVideoPreviewImage
     * @summary Получить превью изображение видео
     * @request GET:/api/help/v1/videos/{videoId}/preview
     * @secure
     */
    getVideoPreviewImage: (videoId: string, params: RequestParams = {}) =>
      this.request<string[], void>({
        path: `/api/help/v1/videos/${videoId}/preview`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Видео
     * @name GetVideoInfo
     * @summary Получить инфо о видео
     * @request GET:/api/help/v1/videos/{videoId}/info
     * @secure
     */
    getVideoInfo: (videoId: string, params: RequestParams = {}) =>
      this.request<VideoContent, void>({
        path: `/api/help/v1/videos/${videoId}/info`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Номер
     * @name GetSupportMobile
     * @summary Получить телефон поддержки
     * @request GET:/api/help/v1/support-mobile
     * @secure
     */
    getSupportMobile: (params: RequestParams = {}) =>
      this.request<string, void>({
        path: `/api/help/v1/support-mobile`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Поиск
     * @name Search
     * @summary Поиск
     * @request GET:/api/help/v1/search
     * @secure
     */
    search: (query: SearchParams, params: RequestParams = {}) =>
      this.request<SearchResponseArticle, void>({
        path: `/api/help/v1/search`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Аудит
     * @name GetVersions
     * @summary Получить версии
     * @request GET:/api/help/v1/nodes/{nodeId}/versions
     * @secure
     */
    getVersions: (nodeId: string, params: RequestParams = {}) =>
      this.request<Record<string, object>, void>({
        path: `/api/help/v1/nodes/${nodeId}/versions`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Категории
     * @name GetCategories
     * @summary Получить все категории
     * @request GET:/api/help/v1/categories
     * @secure
     */
    getCategories: (params: RequestParams = {}) =>
      this.request<Category[], void>({
        path: `/api/help/v1/categories`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Категории
     * @name GetCategoryArticles
     * @summary Получить статьи одной категории
     * @request GET:/api/help/v1/categories/{categoryId}/articles
     * @secure
     */
    getCategoryArticles: (categoryId: string, params: RequestParams = {}) =>
      this.request<Article[], void>({
        path: `/api/help/v1/categories/${categoryId}/articles`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Статьи
     * @name GetFaqArticleUuid
     * @summary Получить статью по ID
     * @request GET:/api/help/v1/articles/{articleUuid}
     * @secure
     */
    getFaqArticleUuid: (articleUuid: string, params: RequestParams = {}) =>
      this.request<Article, void>({
        path: `/api/help/v1/articles/${articleUuid}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Статьи
     * @name GetImage
     * @summary Получить изображение из статьи по ID
     * @request GET:/api/help/v1/articles/{articleId}/{fieldName}
     * @secure
     */
    getImage: (
      articleId: string,
      fieldName: string,
      params: RequestParams = {}
    ) =>
      this.request<File, void>({
        path: `/api/help/v1/articles/${articleId}/${fieldName}`,
        method: "GET",
        secure: true,
        format: "formData",
        ...params,
      }),
  };
}

export const api = new Api();
